import { list } from 'postcss';
import fillProduct from './fillProduct';
import { toggleOverlay, getLocationData, sendAPIRequest, getFacet, getUser } from './utils';
const RELEWISE_DATASET_ID = relewiseData.relewise_dataset_id;
const RELEWISE_API_KEY = 'Bearer ' + relewiseData.relewise_api_key;
const RELEWISE_SERVER_URL = relewiseData.relewise_server_url;
const searchResultElement = document.querySelector('.relewise-search');

if (!customElements.get('relewise-search') && RELEWISE_API_KEY && RELEWISE_DATASET_ID && RELEWISE_SERVER_URL && searchResultElement) {
  /**
   *  @class
   *  @function RelewiseSearch
  */
  class RelewiseSearch extends HTMLElement {
    constructor() {
      super();
      this.boundFacetHeaderClickHandler = this.onFacetHeaderClick.bind(this);
      this.hasFacetHeaderDelegation = false;
      this.facetHeaderDelegationRoot = null;
      this.init();
    }

    connectedCallback() {
      this.activateFacetHeaderDelegation();
    }

    disconnectedCallback() {
      this.facetHeaderDelegationRoot?.removeEventListener('click', this.boundFacetHeaderClickHandler);
      this.facetHeaderDelegationRoot = null;
      this.hasFacetHeaderDelegation = false;
    }

    async init() {
      toggleOverlay(true);
      this.toggleDescVisibility();
      this.page = 1;
      this.searchterm = new URLSearchParams(window.location.search).get('q') || '';
      if (this.searchterm.length === 13 && this.searchterm.charAt(0) === '0') {
        this.searchterm = this.searchterm.substring(1);
        console.log('first 0 cut due to special barcode search rule, now searching for:', this.searchterm);
      }
      this.language = relewiseData.current_locale;
      this.currency = relewiseData.current_currency;
      this.sizeGroups = relewiseData.size_filter_groups;
      this.sortType = {};
      this.activeFilters = {
        'filter-vendor': [],
        'filter-salesprice': {
          "upperBoundInclusive": '',
          "lowerBoundInclusive": ''
        },
        'filter-producttype': [],
        'filter-option1': [],
        'filter-commercial_color': [],
        'filter-kon': [],
        'filter-locations_with_inventory': [],
      };

      this.desktopFacets = document.querySelector('#filter');
      this.desktopFacetsList = document.querySelector('#FilteringAndSorting .border-b');
      this.searchResultElement = document.querySelector('.relewise-search');
      this.paginationWrapper = this.searchResultElement.querySelector('nav[role="navigation"]');
      this.productsPerPage = this.searchResultElement.getAttribute('data-products-per-page');
      this.activateFacetHeaderDelegation();

      this.locations = await getLocationData();
      this.getActiveFiltersFromURL();
      this.getPaginationStatus();

      this.template = relewiseData.current_template ? relewiseData.current_template : 'search';

      this.searchResultData = await this.getSearchResultData();

      if (!this.searchResultData) return;

      if (this.searchResultData.hits === 0) {
        this.noSearchResults();
      } else {
        this.resultAmount = this.searchResultData.hits;
        this.renderSearchResults(this.searchResultData.results);
        this.activatePagination(1);
        this.activateSorting();
        this.setupFacets();

        const updatePage = async (e) => {
          e.preventDefault();
          this.page = parseInt(e.target.closest('.link--bg-pagination').getAttribute('data-page'));
          this.getPaginationStatus();
          this.searchResultData = await this.getSearchResultData();
          this.resultAmount = this.searchResultData.hits;
          this.updateURL();
          this.renderSearchResults(this.searchResultData.results);
          this.setPaginationTextClassic();
        };

        const previousPage = this.paginationWrapper.querySelector('.link--bg-pagination:first-of-type');
        const nextPage = this.paginationWrapper.querySelector('.link--bg-pagination:last-of-type');
        nextPage.addEventListener('click', (e) => {
          const nearestPaginationBtn = e.target.closest('.link--bg-pagination');
          const pageNumber = nearestPaginationBtn?.getAttribute('data-page')
          if (pageNumber && !isNaN(parseInt(pageNumber)) && parseInt(pageNumber) != this.page) {
            updatePage(e);
            window.scrollTo(0, 0);
          }
        });
        previousPage.addEventListener('click', (e) => {
          const nearestPaginationBtn = e.target.closest('.link--bg-pagination');
          const pageNumber = nearestPaginationBtn?.getAttribute('data-page')
          if (pageNumber && !isNaN(parseInt(pageNumber)) && parseInt(pageNumber) != this.page) {
            updatePage(e);
            window.scrollTo(0, 0);
          }
        });
      }

      toggleOverlay(false);
    }

    async noSearchResults() {
      const sortWrapper = document.querySelector('.relewise-search #Sorting');
      const filterWrapper = document.querySelector('.relewise-search #filter');
      const resultTextWrap = document.querySelector('.relewise-search .search-header-text');
      const mobileFilterWrapper = document.querySelector('.relewise-search #open-filter-mobile');
      const tryPopularHeader = document.querySelector('.relewise-search .no-results-try-popular');
      const filterAndProductWrapper = document.querySelector('.relewise-search .filters-and-product-grid');

      resultTextWrap.innerHTML = document.querySelector('.relewise-search .search-header').getAttribute('data-no-results');
      sortWrapper.classList.add('hidden');
      mobileFilterWrapper.classList.add('hidden');
      filterWrapper.classList.add('!hidden');
      tryPopularHeader.classList.remove('hidden');
      filterAndProductWrapper.classList.add('mt-4', 'md:mt-6');
      filterAndProductWrapper.classList.remove('mt-10');

      if (!relewiseData.popular_products == "") {
        this.popularProducts = relewiseData.popular_products;
      } else {
        this.popularProducts = await this.getPopularProducts();
        relewiseData.popular_products = this.popularProducts;
      }
      this.renderSearchResults(this.popularProducts.recommendations);
    }

    getActiveFiltersFromURL() {
      this.initialURL = window.location.href;
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.entries().forEach(param => {
        if (param[0].includes('filter.')) {
          const filterName = param[0].split('filter.')[1];
          const filterValue = param[1].replaceAll('%2C', ',').replaceAll('%2F', '/').replaceAll('%3A', ':').replaceAll('%2B', '+').replaceAll('%2D', '-').replaceAll('%2E', '.').replaceAll('%3D', '=').replaceAll('%3F', '?').replaceAll('%5B', '[').replaceAll('%5D', ']').replaceAll('%5E', '^').replaceAll('%60', '`').replaceAll('%27', "'").replaceAll('%7C', '|').replaceAll('%7E', '~');
          if (filterName.includes('price.')) {
            if (filterName.includes('lower')) {
              this.activeFilters['filter-salesprice'].lowerBoundInclusive = parseInt(filterValue);
            } else if (param.includes('greater')) {
              this.activeFilters['filter-salesprice'].upperBoundInclusive = parseInt(filterValue);
            }
          } else {
            const editedFilterName = 'filter-' + filterName.toLowerCase();
            const editedFilterValue = filterValue.replaceAll('%20', ' ').replaceAll('%C3%B8', 'ø').replaceAll('%C3%A6', 'æ').replaceAll('%C3%A5', 'å').replaceAll('%C3%98', 'Ø').replaceAll('%C3%86', 'Æ').replaceAll('%C3%85', 'Å');

            // Initialize the filter array if it doesn't exist
            if (!this.activeFilters[editedFilterName]) {
              this.activeFilters[editedFilterName] = [];
            }

            this.activeFilters[editedFilterName].push(editedFilterValue);
          }
        } else if (param[0].includes('page')) {
          this.page = parseInt(param[1]);
          this.getPaginationStatus();
        } else if (param[0].includes('sort')) {
          const sortValue = param[1];
          this.setSort(sortValue, false);
          const sortSelect = this.searchResultElement?.querySelector('#SortBy');
          if (sortSelect) {
            sortSelect.querySelector('option[selected="selected"]')?.removeAttribute('selected');
            const optionToSelect = sortSelect.querySelector('option[value="' + sortValue + '"]');
            if (optionToSelect) {
              optionToSelect.setAttribute('selected', 'selected');
            }
          }
        }
      });
    }

    updateURL() {
      let newURL = this.initialURL.split('&')[0];
      for (const filterName in this.activeFilters) {
        if (filterName == 'filter-salesprice') {
          if (this.activeFilters[filterName].lowerBoundInclusive != '') newURL += '&filter.price.lower=' + this.activeFilters[filterName].lowerBoundInclusive;
          if (this.activeFilters[filterName].upperBoundInclusive != '') newURL += '&filter.price.greater=' + this.activeFilters[filterName].upperBoundInclusive;
        } else {
          this.activeFilters[filterName].forEach(filterValue => {
            newURL += '&filter.' + filterName.replace('filter-', '').toLowerCase() + '=' + filterValue;
          })
        }
      }
      if (this.paginationStyle === 'paginated') newURL += '&page=' + this.page;
      if (this.sortType && this.sortType.Value) {
        let sortType;
        if (this.sortType.Value.$type === "Relewise.Client.DataTypes.Search.Sorting.Product.ProductPopularitySorting, Relewise.Client" && this.sortType.Value.Order == 'Descending') sortType = 'best-selling';
        if (this.sortType.Value.$type === "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client" && this.sortType.Value.order == 'Ascending' && this.sortType.Value.attribute == 'SalesPrice') sortType = 'price-ascending';
        if (this.sortType.Value.$type === "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client" && this.sortType.Value.order == 'Descending' && this.sortType.Value.attribute == 'SalesPrice') sortType = 'price-descending';
        if (this.sortType.Value.$type === "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client" && this.sortType.Value.order == 'Ascending' && this.sortType.Value.attribute == 'DisplayName') sortType = 'alphabetic-ascending';
        if (this.sortType.Value.$type === "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client" && this.sortType.Value.order == 'Descending' && this.sortType.Value.attribute == 'DisplayName') sortType = 'alphabetic-descending';
        if (this.sortType.Value.$type === "Relewise.Client.DataTypes.Search.Sorting.Product.ProductDataSorting, Relewise.Client" && this.sortType.Value.order == 'Ascending' && this.sortType.Value.key == 'intersport-dk.myshopify.com_PublishedAt') sortType = 'oldest';
        if (this.sortType.Value.$type === "Relewise.Client.DataTypes.Search.Sorting.Product.ProductDataSorting, Relewise.Client" && this.sortType.Value.order == 'Descending' && this.sortType.Value.key == 'intersport-dk.myshopify.com_PublishedAt') sortType = 'newest';

        newURL += '&sort=' + sortType;
      }
      window.history.pushState({}, '', newURL);
    }



    setupFacets() {
      this?.searchResultData?.facets?.items?.forEach(facet => {
        if (facet.$type === "Relewise.Client.DataTypes.Search.Facets.Result.PriceRangeFacetResult, Relewise.Client") {
          this.setupPriceFacet(facet);
        } else if (facet.$type === "Relewise.Client.DataTypes.Search.Facets.Result.ProductDataStringValueFacetResult, Relewise.Client") {
          this.setupListFacetWOSwatches(facet);
        } else if (facet.$type === "Relewise.Client.DataTypes.Search.Facets.Result.VariantSpecificationFacetResult, Relewise.Client") {
          this.setupGridFacets(facet);
        }
      });

      this.activateFacetItems()
      this.activateFacetHeaders();
    }

    activateFacetItems() {
      const facetItems = document.querySelectorAll('#FilteringAndSorting .filter .facet input[type=checkbox]');
      facetItems?.forEach(facetItem => {
        facetItem.removeEventListener('change', (e) => this.facetItemClickHandler(e, facetItem));
        facetItem.addEventListener('change', (e) => this.facetItemClickHandler(e, facetItem));
      });
    }

    async facetItemClickHandler(e, facetItem) {
      const filterName = facetItem.name.toLowerCase();
      const filterValue = facetItem.value;
      if (facetItem.checked) {
        this.activeFilters[filterName].push(filterValue);
      } else {
        this.activeFilters[filterName] = this.activeFilters[filterName].filter(filter => filter !== filterValue);
      }
      this.resetPaginationAndUpdateResults();
      this.updateURL();
    }

    updateFacetList(filterName) {
      const facetNameHandlized = filterName ? this.handlizeString(filterName) : '';
      const listID = 'facet-list-' + filterName.replace('filter-', '');
      const list = document.getElementById(listID);

      if (!list) return;
      const facetWrapper = list.closest('.filter');
      const facet = getFacet(filterName, this.searchResultData);
      if (!facet) return;
      const activeCount = this.activeFilters[filterName].length;

      if (activeCount > 0) {
        facetWrapper.querySelector('.active-count').textContent = activeCount;
        facetWrapper.querySelector('.active-count').classList.remove('hidden');
        facetWrapper.querySelector('.filter__label-icons').classList.add('hidden');
      } else {
        facetWrapper.querySelector('.active-count').classList.add('hidden');
        facetWrapper.querySelector('.filter__label-icons').classList.remove('hidden');
      }

      list.innerHTML = '';
      this.fillValues(facetWrapper, facet, facetNameHandlized, listID)

      const hasAvailableValues = facet?.available?.length > 0;
      facetWrapper.classList.toggle('hidden', !hasAvailableValues);
    }

    updateFacetGrid(filterName) {
      const facetNameHandlized = filterName ? this.handlizeString(filterName) : '';
      const listID = 'facet-list-' + filterName.replace('filter-', '');
      const list = document.getElementById(listID);

      if (!list) return;
      const facetWrapper = list.closest('.filter');
      const facet = getFacet(filterName, this.searchResultData);
      if (!facet) return;
      const activeCount = this.activeFilters[filterName].length;

      if (activeCount > 0) {
        facetWrapper.querySelector('.active-count').textContent = activeCount;
        facetWrapper.querySelector('.active-count').classList.remove('hidden');
        facetWrapper.querySelector('.filter__label-icons').classList.add('hidden');
      } else {
        facetWrapper.querySelector('.active-count').classList.add('hidden');
        facetWrapper.querySelector('.filter__label-icons').classList.remove('hidden');
      }

      list.innerHTML = '';
      this.fillSizes(facetWrapper, facet, facetNameHandlized, listID)

      const hasAvailableValues = facet?.available?.length > 0;
      facetWrapper.classList.toggle('hidden', !hasAvailableValues);
    }

    setupPriceFacet(facet) {
      let facetHeader = document.querySelector('#facet-header-template')?.content.cloneNode(true);
      let priceRange = document.querySelector('#price-filter-template')?.content.cloneNode(true);
      let facetHeaderTitle = this.desktopFacetsList ? this.desktopFacetsList.getAttribute('data-facet-ts-price') : "";

      facetHeader.querySelector('.facet-title').textContent = facetHeaderTitle;

      priceRange = this.fillPriceValues(facet, priceRange);
      facetHeader.querySelector('.filter').appendChild(priceRange);

      this.desktopFacetsList.appendChild(facetHeader);
      this.activatePriceRangeFilter();
    }

    activateFacetHeaders() {
      this.activateFacetHeaderDelegation();
    }

    activateFacetHeaderDelegation() {
      if (this.hasFacetHeaderDelegation) return;
      this.facetHeaderDelegationRoot = document.querySelector('#FilteringAndSorting') || this;
      this.facetHeaderDelegationRoot.addEventListener('click', this.boundFacetHeaderClickHandler);
      this.hasFacetHeaderDelegation = true;
    }

    onFacetHeaderClick(e) {
      const facetLabel = e.target.closest('#FilteringAndSorting .filter__label');
      if (!facetLabel) return;

      const filter = facetLabel.closest('.filter');
      const content = filter?.querySelector('.filter__content');
      if (!filter || !content) return;

      e.preventDefault();

      filter.classList.toggle('filter--open');
      content.classList.toggle('hidden');
    }

    activatePriceRangeFilter() {
      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const filterPriceMinShow = document.querySelector('#filter_price_min_show');
      const filterPriceMaxShow = document.querySelector('#filter_price_max_show');

      fromSlider.addEventListener('input', (e) => {
        const value = parseInt(e.target.value);
        this.activeFilters['filter-salesprice'].lowerBoundInclusive = value;
        filterPriceMinShow.textContent = value;
      });

      toSlider.addEventListener('input', (e) => {
        const value = parseInt(e.target.value);
        this.activeFilters['filter-salesprice'].upperBoundInclusive = value;
        filterPriceMaxShow.textContent = value;
      });

      fromSlider.addEventListener('change', async () => {
        this.resetPaginationAndUpdateResults();
        this.updateURL();
      });

      toSlider.addEventListener('change', async () => {
        this.resetPaginationAndUpdateResults();
        this.updateURL();
      });
    }

    async resetPaginationAndUpdateResults() {
      this.page = 1;
      this.getPaginationStatus();
      this.searchResultData = await this.getSearchResultData();
      this.resultAmount = this.searchResultData.hits;
      document.querySelector('#ProductGridContainer .grid').innerHTML = '';
      this.renderSearchResults(this.searchResultData.results);

      for (const filterName in this.activeFilters) {
        if (filterName == 'filter-salesprice') {
          this.updatePriceFacet(getFacet('filter-salesprice', this.searchResultData));
        } else if (filterName == 'filter-option1') {
          this.updateFacetGrid(filterName.toLowerCase());
        } else {
          this.updateFacetList(filterName.toLowerCase());
        }
      }
      this.activateFacetItems();
      this.setPaginationTextClassic();
      this.updateURL();
    }

    updatePriceFacet(facet) {
      const upperBounds = Math.ceil(facet.available.value.upperBoundInclusive);
      const selectedUpper = this.activeFilters['filter-salesprice'].upperBoundInclusive != '' ? this.activeFilters['filter-salesprice'].upperBoundInclusive : Math.ceil(facet.available.value.upperBoundInclusive);
      const selectedLower = this.activeFilters['filter-salesprice'].lowerBoundInclusive != '' ? this.activeFilters['filter-salesprice'].lowerBoundInclusive : 0;
      const priceRange = document.querySelector('.filter__price__range');

      if (!priceRange || !selectedUpper || !upperBounds) return;

      priceRange.querySelector('#filter_price_max').setAttribute('max', upperBounds);
      priceRange.querySelector('#filter_price_min').setAttribute('max', upperBounds);
      priceRange.querySelector('#fromSlider').setAttribute('max', upperBounds);
      priceRange.querySelector('#toSlider').setAttribute('max', upperBounds);
      priceRange.querySelector('#fromSlider').setAttribute('value', selectedLower);
      priceRange.querySelector('#toSlider').setAttribute('value', selectedUpper);
      priceRange.querySelector('#filter_price_max_show').textContent = selectedUpper;
      priceRange.querySelector('#filter_price_min_show').textContent = selectedLower;
    }

    fillPriceValues(facet, priceRange) {
      const upperBounds = Math.ceil(facet.available.value.upperBoundInclusive);
      const selectedUpper = this.activeFilters['filter-salesprice'].upperBoundInclusive != '' ? this.activeFilters['filter-salesprice'].upperBoundInclusive : Math.ceil(facet.available.value.upperBoundInclusive);
      const selectedLower = this.activeFilters['filter-salesprice'].lowerBoundInclusive != '' ? this.activeFilters['filter-salesprice'].lowerBoundInclusive : 0;

      priceRange.querySelector('#filter_price_max')?.setAttribute('max', upperBounds);
      priceRange.querySelector('#filter_price_min')?.setAttribute('max', upperBounds);
      priceRange.querySelector('#fromSlider').setAttribute('max', upperBounds);
      priceRange.querySelector('#toSlider').setAttribute('max', upperBounds);
      priceRange.querySelector('#fromSlider').setAttribute('value', selectedLower);
      priceRange.querySelector('#toSlider').setAttribute('value', selectedUpper);
      priceRange.querySelector('#filter_price_max_show').textContent = selectedUpper;
      priceRange.querySelector('#filter_price_min_show').textContent = selectedLower;

      return priceRange;
    }

    handlizeString(string) {
      if (!string || typeof string !== 'string') return '';
      return string.toLowerCase().replace(' ', '-').replace('intersport-dk.myshopify.com_custom', '').replace('intersport-dk.myshopify.com_', '').replace('.', '');
    }

    setupGridFacets(facet) {
      const facetWrapperTemplate = document.querySelector("#facet-header-template").content.cloneNode(true);
      const listWrapperTemplate = document.querySelector("#size-filter-outer-template").content.cloneNode(true);
      const facetNameHandlized = this.handlizeString(facet.key);
      const listID = 'facet-list-' + facetNameHandlized;

      const { facetWrapper, listWrapper } = this.fillFacetSummary(facet, facetWrapperTemplate, listWrapperTemplate, facetNameHandlized, listID);

      this.fillSizes(listWrapper, facet, facetNameHandlized, listID)

      facetWrapper.querySelector('.filter').appendChild(listWrapper);

      const hasNoAvailableValues = facet?.available?.length === 0 || 0;
      if (hasNoAvailableValues) facetWrapper.querySelector('.filter').classList.add('hidden');

      this.desktopFacetsList.appendChild(facetWrapper);
    }

    fillSizes(listWrapper, facet, facetNameHandlized, listID) {
      const valueTemplate = document.querySelector("#size-filter-item-template");
      const facetNameHandlizedEdited = facetNameHandlized.includes('filter-') ? facetNameHandlized : 'filter-' + facetNameHandlized;
      let index = 1;
      if (!valueTemplate) return;

      // fill in size groups first in metaobject order
      this.sizeGroups.forEach(group => {
        const valueID = 'Filter-' + facetNameHandlized + '-' + index;
        const filterName = group.label;
        const facetValue = facet.available.find(facetValue => group.values.includes(facetValue.value));
        if (!facetValue) return;
        const valueElement = valueTemplate.content.cloneNode(true);
        valueElement.querySelector('[type=checkbox]').setAttribute('name', facetNameHandlizedEdited);
        valueElement.querySelector('label').setAttribute('for', valueID);

        valueElement.querySelector('label').classList.add('facet-group-label');
        valueElement.querySelector('label').setAttribute('data-group', group.label);
        valueElement.querySelector('label span.size').textContent = filterName;
        valueElement.querySelector('[type=checkbox]').setAttribute('value', filterName);
        valueElement.querySelector('[type=checkbox]').setAttribute('id', valueID);

        if (facetValue.selected) {
          valueElement.querySelector('[type=checkbox]').setAttribute('checked', '');
        } else {
          const isSelectedInGroup = this.sizeGroups.some(group =>
            group.values.includes(filterName) &&
            this.activeFilters['filter-option1'].includes(group.label)
          );
          if (isSelectedInGroup) {
            valueElement.querySelector('[type=checkbox]').setAttribute('checked', '');
          }
        }
        listWrapper.querySelector('#' + listID).appendChild(valueElement);
        index++;
      })

      // fill in the rest of the sizes and hits for the groups
      facet.available.forEach(value => {
        const valueID = 'Filter-' + facetNameHandlized + '-' + index;
        const filterName = value.value.split('_')[1] ? value.value.split('_')[1] : value.value;
        // fill facet - group or standard
        let sizeGroups = this.sizeGroups.filter(group => group.values.includes(filterName));
        if (sizeGroups.length > 0) {
          sizeGroups.forEach(sizeGroup => {
            const groupElement = listWrapper.querySelector('.facet-group-label[data-group="' + sizeGroup.label + '"]');
            if (groupElement) {
              const currentText = groupElement.querySelector('span.count').textContent || 0;
              groupElement.querySelector('span.count').textContent = parseInt(currentText) + value.hits;
            }
          });
        } else {
          // fill ungrouped sizes
          const valueElement = valueTemplate.content.cloneNode(true);
          valueElement.querySelector('[type=checkbox]').setAttribute('name', facetNameHandlizedEdited);
          valueElement.querySelector('label').setAttribute('for', valueID);

          valueElement.querySelector('label span.count').textContent = value.hits;
          valueElement.querySelector('label span.size').textContent = filterName;
          valueElement.querySelector('[type=checkbox]').setAttribute('value', value.value);
          valueElement.querySelector('[type=checkbox]').setAttribute('id', valueID);
          if (value.selected) valueElement.querySelector('[type=checkbox]').setAttribute('checked', '');
          listWrapper.querySelector('#' + listID).appendChild(valueElement);
          index++;
        }
      });
    }

    fillFacetSummary(facet, facetWrapper, listWrapper, facetNameHandlized, listID) {
      const filterName = 'filter-' + this.handlizeString(facet.key);;
      if (facet.selected && this.activeFilters[filterName].length > 0) {
        facetWrapper.querySelector('.active-count').textContent = this.activeFilters[filterName].length;
        facetWrapper.querySelector('.active-count').classList.remove('hidden');
        facetWrapper.querySelector('.filter__label-icons').classList.add('hidden');
      }
      const tsAttributeKey = 'data-facet-ts-' + facetNameHandlized;
      const facetHeaderTitle = this.desktopFacetsList.getAttribute(tsAttributeKey);

      listWrapper.querySelector('ul').setAttribute('id', listID);

      facetWrapper.querySelector('.facet-title').textContent = facetHeaderTitle;
      facetWrapper.querySelector('.filter').setAttribute('data-facet', facetNameHandlized);

      return { facetWrapper, listWrapper };
    }

    setupListFacetWOSwatches(facet) {
      const facetWrapperTemplate = document.querySelector("#facet-header-template").content.cloneNode(true);
      const listWrapperTemplate = document.querySelector("#standard-filter-outer-template").content.cloneNode(true);
      const facetNameHandlized = this.handlizeString(facet.key);
      const listID = 'facet-list-' + facetNameHandlized;

      const { facetWrapper, listWrapper } = this.fillFacetSummary(facet, facetWrapperTemplate, listWrapperTemplate, facetNameHandlized, listID);

      this.fillValues(listWrapper, facet, facetNameHandlized, listID)
      facetWrapper.querySelector('.filter').appendChild(listWrapper);

      const hasNoAvailableValues = facet?.available?.length === 0 || 0;
      if (hasNoAvailableValues) facetWrapper.querySelector('.filter').classList.add('hidden');

      this.desktopFacetsList.appendChild(facetWrapper);
    }

    fillValues(listWrapper, facet, facetNameHandlized, listID) {
      const valueTemplate = document.querySelector("#standard-filter-item-template");
      const facetNameHandlizedEdited = facetNameHandlized.includes('filter-') ? facetNameHandlized : 'filter-' + facetNameHandlized;

      if (!valueTemplate) return;
      if (!Array.isArray(facet?.available)) return;
      if (facetNameHandlizedEdited == 'filter-locations_with_inventory') {
        facet.available = facet.available.map(value => {
          const location = this.locations.find(location => location.id == "gid://shopify/Location/" + value.value);
          value.cleaned_name = location?.name ? location.name.replace('INTERSPORT ', '') : String(value?.value || '');
          return value;
        });
      } else {
        facet.available = facet.available.map(value => {
          const rawValue = String(value?.value || '');
          value.cleaned_name = rawValue.includes('_') ? rawValue.split('_')[1] : rawValue;
          return value;
        });
      }

      facet.available = facet.available.filter((value) => value?.cleaned_name);
      facet.available.sort((a, b) => String(a.cleaned_name).localeCompare(String(b.cleaned_name)));

      let index = 1;
      facet.available.forEach(value => {
        if (!value.value) return;
        const valueElement = valueTemplate.content.cloneNode(true);
        const valueID = 'Filter-' + facetNameHandlized + '-' + index;
        const filterName = value.cleaned_name;

        valueElement.querySelector('[type=checkbox]').setAttribute('name', facetNameHandlizedEdited);

        // fill facet
        valueElement.querySelector('.custom-checkbox-flex span').textContent = value.hits;
        valueElement.querySelector('.facet-item-name').textContent = filterName;
        valueElement.querySelector('[type=checkbox]').setAttribute('value', value.value);
        valueElement.querySelector('[type=checkbox]').setAttribute('id', valueID);
        valueElement.querySelector('label').setAttribute('for', valueID);
        if (value.selected) valueElement.querySelector('[type=checkbox]').setAttribute('checked', '');

        listWrapper.querySelector('#' + listID).appendChild(valueElement);
        index++;
      });
    }

    getPaginationStatus() {
      this.paginationStyle = 'paginated'; // hardcoded for now
      this.skipProducts = (this.page - 1) * this.productsPerPage;
    }

    setPaginationTextClassic() {
      const totalPages = Math.ceil(this.resultAmount / this.productsPerPage);
      const linkClasses = ["px-2", "py-3", "h-6", "w-10", "items-center", "flex", "justify-center", "align-center", "font-semibold", "cursor-pointer"];
      const currentPageSpanClasses = ["flex", "w-10", "h-6", "justify-center", "font-bold"];
      const currentPageDivClasses = ["flex", "h-5", "w-5", "mb-px", "bg-foreground", "text-background", "font-bold", "justify-center", "items-center", "hover:bg-accent"];
      const navigationWrapper = this.paginationWrapper.querySelector('.page-links');
      const previousPage = this.paginationWrapper.querySelector('.link--bg-pagination:first-of-type');
      const nextPage = this.paginationWrapper.querySelector('.link--bg-pagination:last-of-type');
      const arrowInactiveClasses = ["bg-grey-200", "opacity-50", "border-0"];

      navigationWrapper.innerHTML = '';

      if (totalPages > 1) {
        const paginationData = [
          { 'name': 'firstPage', 'value': 1 },
          { 'name': 'dots1', 'value': 'dots' },
          { 'name': 'pageMinusTwo', 'value': this.page - 2 },
          { 'name': 'pageMinusOne', 'value': this.page - 1 },
          { 'name': 'currentPage', 'value': this.page },
          { 'name': 'pagePlusOne', 'value': this.page + 1 },
          { 'name': 'pagePlusTwo', 'value': this.page + 2 },
          { 'name': 'dots2', 'value': 'dots' },
          { 'name': 'lastPage', 'value': totalPages },
        ];

        paginationData.forEach(page => {
          if (page.name === 'currentPage') {
            const currentPage = document.createElement('div');
            const currentPageInner = document.createElement('span');
            currentPage.classList.add(...currentPageDivClasses);
            currentPageInner.classList.add(...currentPageSpanClasses);
            currentPageInner.textContent = this.page;
            currentPage.appendChild(currentPageInner);

            navigationWrapper.appendChild(currentPage);

          } else if (page.name.includes('dots')) {
            const dots = document.createElement('span');
            dots.classList.add('flex', 'w-10', 'h-6', 'text-grey-400', 'justify-center', 'font-bold');
            dots.textContent = '…'

            if (page.name == 'dots2' && this.page != totalPages && this.page + 1 != totalPages && this.page + 2 != totalPages && this.page + 3 != totalPages || page.name == 'dots2' && this.page + 3 < totalPages && this.page != totalPages) navigationWrapper.appendChild(dots);
            if (page.name == 'dots1' && this.page - 3 > 1) navigationWrapper.appendChild(dots);

          } else {
            const pageDiv = document.createElement('div');
            pageDiv.classList.add(...linkClasses);
            pageDiv.textContent = page.value;
            pageDiv.setAttribute('data-page', page.value);
            pageDiv.addEventListener('click', async (e) => {
              this.page = parseInt(e.target.getAttribute('data-page'));
              this.getPaginationStatus();
              this.searchResultData = await this.getSearchResultData();
              this.resultAmount = this.searchResultData.hits;
              this.updateURL();
              this.renderSearchResults(this.searchResultData.results);
              this.setPaginationTextClassic();
              window.scrollTo(0, 0);
            });

            if (page.name == 'lastPage' && totalPages != this.page) navigationWrapper.appendChild(pageDiv);
            if (page.name == 'pagePlusTwo' && this.page + 2 != totalPages && this.page + 2 < totalPages) navigationWrapper.appendChild(pageDiv);
            if (page.name == 'pagePlusOne' && this.page + 1 != totalPages && this.page + 1 < totalPages) navigationWrapper.appendChild(pageDiv);
            if (page.name == 'pageMinusOne' && this.page - 1 != 1 && this.page - 1 > 1) navigationWrapper.appendChild(pageDiv);
            if (page.name == 'pageMinusTwo' && this.page - 2 != 1 && this.page - 2 > 1) navigationWrapper.appendChild(pageDiv);
            if (page.name == 'firstPage' && 1 != this.page) navigationWrapper.appendChild(pageDiv);
          }
        });

        // add classes to arrows
        if (parseInt(this.page) === 1) {
          previousPage.classList.add(...arrowInactiveClasses);
          previousPage.removeAttribute('data-page');
        } else {
          previousPage.classList.remove(...arrowInactiveClasses);
          previousPage.setAttribute('data-page', (parseInt(this.page) - 1));
        }
        if (parseInt(this.page) === totalPages) {
          nextPage.removeAttribute('data-page');
          nextPage.classList.add(...arrowInactiveClasses);
        } else {
          nextPage.classList.remove(...arrowInactiveClasses);
          nextPage.setAttribute('data-page', (parseInt(this.page) + 1));
        }

        // show the pagination
        this.paginationWrapper.classList.remove('hidden')
      }
      else {
        this.paginationWrapper.classList.add('hidden');
      }
    }

    async activateSorting() {
      searchResultElement.querySelectorAll('.sort-by-button.relewise').forEach(sortBtn => {
        sortBtn.addEventListener('change', async (e) => {
          const type = e.target.value;
          this.setSort(type);
        });
      })
    }

    setSort(type, updateURLandResults = true) {
      const ascendingPriceSort = {
        "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client",
        "order": "Ascending",
        "attribute": "SalesPrice",
        "mode": "Auto",
        "thenBy": {
          "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client",
          "order": "Descending",
          "mode": "Auto"
        }
      };
      const descendingPriceSort = {
        "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client",
        "order": "Descending",
        "attribute": "SalesPrice",
        "mode": "Auto",
        "thenBy": {
          "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client",
          "order": "Descending",
          "mode": "Auto"
        }
      };
      const ascendingAlphabeticalSort = {
        "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client",
        "order": "Ascending",
        "attribute": "DisplayName",
        "mode": "Auto",
        "thenBy": {
          "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client",
          "order": "Descending",
          "mode": "Auto"
        }
      };
      const descendingAlphabeticalSort = {
        "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductAttributeSorting, Relewise.Client",
        "order": "Descending",
        "attribute": "DisplayName",
        "mode": "Auto",
        "thenBy": {
          "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client",
          "order": "Descending",
          "mode": "Auto"
        }
      };
      const oldestSort = {
        "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductDataSorting, Relewise.Client",
        "order": "Ascending",
        "dataSelectionStrategy": "Product",
        "mode": "Auto",
        "key": "intersport-dk.myshopify.com_PublishedAt",
        "thenBy": {
          "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client",
          "order": "Descending",
          "mode": "Auto"
        }
      };
      const newestSort = {
        "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductDataSorting, Relewise.Client",
        "order": "Descending",
        "dataSelectionStrategy": "Product",
        "mode": "Auto",
        "key": "intersport-dk.myshopify.com_PublishedAt",
        "thenBy": {
          "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client",
          "order": "Descending",
          "mode": "Auto"
        }
      };
      const bestsellerSort = {
        "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductPopularitySorting, Relewise.Client",
        "Order": "Descending",
        "ThenBy": {
          "$type": "Relewise.Client.DataTypes.Search.Sorting.Product.ProductRelevanceSorting, Relewise.Client",
          "Order": "Descending"
        }
      };

      if (type === 'price-ascending') {
        this.sortType = { "Value": ascendingPriceSort };
      } else if (type === 'price-descending') {
        this.sortType = { "Value": descendingPriceSort };
      } else if (type === 'alphabetic-ascending') {
        this.sortType = { "Value": ascendingAlphabeticalSort };
      } else if (type === 'alphabetic-descending') {
        this.sortType = { "Value": descendingAlphabeticalSort };
      } else if (type === 'oldest') {
        this.sortType = { "Value": oldestSort };
      } else if (type === 'newest') {
        this.sortType = { "Value": newestSort };
      } else if (type === 'best-selling') {
        this.sortType = { "Value": bestsellerSort };
      } else {
        this.sortType = {};
      }
      if (updateURLandResults) this.resetPaginationAndUpdateResults()
    }

    async activatePagination() {
      this.setPaginationTextClassic();
    }

    toggleDescVisibility() {
      const headerDesc = document.querySelector('.template-header--description');
      if (headerDesc) {
        headerDesc.classList.toggle('is-hidden');
      }
    }

    setResultAmount() {
      const searchHeader = document.querySelector('.relewise-search .search-header div');
      if (!searchHeader) return;
      if (searchHeader.querySelector('.count')) searchHeader.querySelector('.count').remove();

      const span = document.createElement('span');
      span.classList.add('count', 'inline-flex', 'items-center', 'mt-2', 'text-sm', 'md:text-base', 'leading-none', 'text-accent', 'ml-1');
      span.textContent = this.resultAmount;
      searchHeader.appendChild(span);
      if (this.resultAmount == 1) {
        document.querySelector('.relewise-search .search-header .search-header-text').innerHTML = document.querySelector('.relewise-search .search-header').getAttribute('data-with-results');
        const titleText = document.querySelector('.relewise-search .search-header').getAttribute('data-tab-ts-results-single').replace('{{ count }}', this.resultAmount).replace('{{ key }}', this.searchterm);
        document.title = titleText;
      } else if (this.resultAmount > 1) {
        document.querySelector('.relewise-search .search-header .search-header-text').innerHTML = document.querySelector('.relewise-search .search-header').getAttribute('data-with-results');
        const titleText = document.querySelector('.relewise-search .search-header').getAttribute('data-tab-ts-results-plural').replace('{{ count }}', this.resultAmount).replace('{{ key }}', this.searchterm);
        document.title = titleText;
      } else {
        document.querySelector('.relewise-search .search-header .search-header-text').innerHTML = document.querySelector('.relewise-search .search-header').getAttribute('data-no-results');
        const titleText = document.querySelector('.relewise-search .search-header').getAttribute('data-tab-ts-no-results').replace('{{ terms }}', this.searchterm);
        document.title = titleText;
      }
    }

    async getPopularProducts() {
      const relewiseSearchAPIEndpoint = RELEWISE_SERVER_URL + RELEWISE_DATASET_ID + '/v1/PopularProductsRequest';
      const body = {
        "$type": "Relewise.Client.Requests.Recommendations.PopularProductsRequest, Relewise.Client",
        "BasedOn": "MostPurchased",
        "displayedAtLocation": this.template,
        "SinceMinutesAgo": 20160,
        "Settings": {
          "NumberOfRecommendations": 8,
          "AllowFillIfNecessaryToReachNumberOfRecommendations": true,
          "AllowReplacingOfRecentlyShownRecommendations": true,
          "RecommendVariant": true,
          "ExplodedVariants": 0,
          "SelectedProductProperties": {
            "$type": "Relewise.Client.Requests.Shared.SelectedProductPropertiesSettings, Relewise.Client",
            "DisplayName": true,
            "CategoryPaths": true,
            "Assortments": true,
            "Pricing": true,
            "AllData": true,
            "AllVariants": true,
          },
          "selectedVariantProperties": {
            "displayName": true,
            "allData": true,
          },
          "PrioritizeDiversityBetweenRequests": false,
        },
        "language": {
          "value": 'da'
        },
        "currency": {
          "value": this.currency
        },
        "user": await getUser()
      }
      return await sendAPIRequest(relewiseSearchAPIEndpoint, body, RELEWISE_API_KEY);
    }

    getSizeFacetGroupValues() {
      let activeFiltersIncludingAllFacetsFromGroups = [];
      this.activeFilters['filter-option1'].forEach(filter => {
        const sizeGroup = this.sizeGroups.find(group => group.label.toLowerCase() === filter.toLowerCase());
        if (sizeGroup) {
          sizeGroup.values.forEach(value => {
            if (this.searchResultData !== undefined) {
              const facets = this.searchResultData?.facets?.items[3]
              if (!facets) return;
              const availableFacet = facets.available.find(facetValue => facetValue.value === value);
              if (availableFacet) {
                activeFiltersIncludingAllFacetsFromGroups.push(value);
              }
            } else {
              activeFiltersIncludingAllFacetsFromGroups.push(value);
            }

          });
        } else {
          activeFiltersIncludingAllFacetsFromGroups.push(filter);
        }
      });
      return activeFiltersIncludingAllFacetsFromGroups;
    }

    async getSearchResultData() {
      toggleOverlay(true);
      const vendorFacets = this.activeFilters['filter-vendor'];
      const productTypeFacets = this.activeFilters['filter-producttype'];
      const genderFacets = this.activeFilters['filter-kon'];
      const colorFacets = this.activeFilters['filter-commercial_color'];
      const storeFacets = this.activeFilters['filter-locations_with_inventory'];
      const upperBoundInclusive = this.activeFilters['filter-salesprice'].upperBoundInclusive;
      const lowerBoundInclusive = this.activeFilters['filter-salesprice'].lowerBoundInclusive;
      const sizeFacets = this.getSizeFacetGroupValues();
      const relewiseSearchAPIEndpoint = RELEWISE_SERVER_URL + RELEWISE_DATASET_ID + '/v1/ProductSearchRequest';
      const body = {
        "term": this.searchterm,
        "$type": "Relewise.Client.Requests.Search.ProductSearchRequest, Relewise.Client",
        "displayedAtLocation": this.template,
        "settings": {
          "ExplodedVariants": 1,
          "selectedProductProperties": {
            "displayName": true,
            "categoryPaths": true,
            "pricing": true,
            "allData": true,
            "brand": true,
            "allVariants": true
          },
          "selectedVariantProperties": {
            "displayName": true,
            "allData": true,
          }
        },
        "skip": this.skipProducts,
        "take": this.productsPerPage,
        "language": {
          "value": 'da'
        },
        "currency": {
          "value": this.currency
        },
        "user": await getUser(),
        "Sorting": this.sortType,
        "Facets": {
          "Items": [
            {
              "$type": "Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataStringValueFacet, Relewise.Client",
              "DataSelectionStrategy": "Product",
              "Key": "Vendor",
              "Selected": vendorFacets,
              "Field": "Data"
            },
            {
              "$type": "Relewise.Client.DataTypes.Search.Facets.Queries.PriceRangeFacet, Relewise.Client",
              "Field": "SalesPrice",
              "PriceSelectionStrategy": "Product",
              "Selected": { "upperBoundInclusive": upperBoundInclusive, "lowerBoundInclusive": lowerBoundInclusive },
            },
            {
              "$type": "Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataStringValueFacet, Relewise.Client",
              "DataSelectionStrategy": "Product",
              "Key": "ProductType",
              "Selected": productTypeFacets,
              "Field": "Data"
            },
            {
              "$type": "Relewise.Client.DataTypes.Search.Facets.Queries.VariantSpecificationFacet, Relewise.Client",
              "Key": "Option1",
              "Selected": sizeFacets,
              "Field": 'Data'
            },
            {
              "$type": "Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataStringValueFacet, Relewise.Client",
              "DataSelectionStrategy": "Product",
              "Key": "intersport-dk.myshopify.com_custom.kon",
              "Selected": genderFacets,
              "Field": "Data"
            },
            {
              "$type": "Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataStringValueFacet, Relewise.Client",
              "DataSelectionStrategy": "Product",
              "Key": "intersport-dk.myshopify.com_custom.commercial_color",
              "Selected": colorFacets,
              "Field": "Data"
            },
            {
              "$type": "Relewise.Client.DataTypes.Search.Facets.Queries.ProductDataStringValueFacet, Relewise.Client",
              "DataSelectionStrategy": "Variant",
              "Key": "intersport-dk.myshopify.com_custom.locations_with_inventory",
              "Selected": storeFacets,
              "Field": "Data"
            },
          ]
        },
        "Filters": {
          "$type": "Relewise.Client.Requests.Filters.FilterCollection, Relewise.Client",
          "Items": [
            {
              "$type": "Relewise.Client.Requests.Filters.VariantDataFilter, Relewise.Client",
              "Key": "intersport-dk.myshopify.com_SellableOnlineQuantity",
              "FilterOutIfKeyIsNotFound": true,
              "MustMatchAllConditions": true,
              "Conditions": {
                "Items": [
                  {
                    "$type": "Relewise.Client.Requests.Conditions.GreaterThanCondition, Relewise.Client",
                    "Value": 0.0,
                    "TypeName": "GreaterThanCondition",
                    "Negated": false
                  }
                ]
              },
              "Language": {
                "Value": "da"
              },
              "Currency": {
                "Value": this.currency
              },
              "TypeName": "VariantDataFilter",
              "Negated": false
            }
          ]
        }
      };

      return await sendAPIRequest(relewiseSearchAPIEndpoint, body, RELEWISE_API_KEY);
    }

    renderSearchResults(products) {
      const searchResultGrid = document.querySelector('#ProductGridContainer .grid');
      if (this.paginationStyle == 'paginated') searchResultGrid.innerHTML = '';
      if (searchResultGrid && products) {
        products.forEach(product => {
          // Build product card from template
          const productCard = fillProduct(product);
          searchResultGrid.appendChild(productCard);
        });
      }
      this.setResultAmount();
      toggleOverlay(false);
    }
  }

  customElements.define('relewise-search', RelewiseSearch);
  new RelewiseSearch();
}
